import * as types from '../../constants/app/fileUploadConstant';

export const folderListRequest = ({ container, callback, error }) => ({
  type: types.FOLDER_LIST_REQUEST,
  container,
  callback,
  error,
});

export const fileListRequest = ({
  container,
  folderName,
  callback,
  error,
}) => ({
  type: types.FILE_LIST_REQUEST,
  container,
  folderName,
  callback,
  error,
});
